// tslint:disable:no-any
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { push } from 'react-router-redux';

import { loadDives, loadSharedDives } from '../actions/diveActions';
import DivesMap from '../components/DivesMap';
import DivesTable from '../components/DivesTable';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Stats from '../components/Stats';
import Title from '../components/Title';
import Dt from 'react-document-title';
import { NavigationStore } from '../components/Navigation/NavigationStore';

// import Navigation from '../components/Navigation';
export interface IDashboardProps {
    location: any;
    loadSharedDives: any;
    loadDives: any;
    dives: any;
    sharedDives: any;
    viewDetail: any;
    viewSharedDetail: any;
    editDive: any;
}

interface IDashboardState {
    message: any;
    messageType: any;
    redirectToDashboard: boolean;
}

class Dashboard extends Component<IDashboardProps, IDashboardState> {
    constructor(props: IDashboardProps) {
        super(props);
        this.state = {
            message: null,
            messageType: null,
            redirectToDashboard: false
        };
    }

    componentDidMount() {
        this.refreshDives();
        NavigationStore.getInstance().setActive('dashboard');
        // Navigation._setActive('dashboard', 'Dashboard');
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps: IDashboardProps) {
        if (
            nextProps.location &&
            nextProps.location.state &&
            nextProps.location.state.message &&
            nextProps.location.state.messageType
        ) {
            this.setState({
                message: nextProps.location.state.message,
                messageType: nextProps.location.state.messageType
            });
        }
    }

    refreshDives() {
        this.props.loadSharedDives();
        this.props.loadDives();
    }

    clearMessage() {
        this.setState({
            message: null,
            messageType: null,
            redirectToDashboard: true
        });
    }

    render() {
        const {
            dives,
            sharedDives,
            viewDetail,
            viewSharedDetail,
            editDive
        } = this.props;

        if (
            dives.userDives === undefined ||
            sharedDives.sharedDives === undefined
        ) {
            return <Loader />;
        }

        return (
            <Dt title={'WetNotes | Dashboard'}>
                <div className="dashboard">
                    <Title />

                    <div className="wrapper cf">
                        <Stats type="dashboard" dives={dives} />

                        {this.state.redirectToDashboard && (
                            <Redirect to="/app" />
                        )}

                        {this.state.message !== null && (
                            <div className="messages">
                                <Message
                                    type={this.state.messageType}
                                    text={this.state.message}
                                    autoClose={true}
                                    onClose={() => this.clearMessage()}
                                />
                            </div>
                        )}

                        <DivesMap
                            dives={dives}
                            sharedDives={sharedDives}
                            viewDetail={viewDetail}
                            viewSharedDetail={viewSharedDetail}
                        />

                        <DivesTable
                            title="My Dives"
                            shared={false}
                            dives={dives.userDives}
                            filtering={false}
                            viewDetail={viewDetail}
                            editDive={editDive}
                            refreshDives={() => this.refreshDives()}
                        />
                    </div>
                </div>
            </Dt>
        );
    }
}

const mapStateToProps = (state: any) => ({
    dives: state.dives.items || [],
    sharedDives: state.sharedDives.items || []
});

const mapDispatchToProps = (dispatch: any) => ({
    loadDives: () => dispatch(loadDives()),
    loadSharedDives: () => dispatch(loadSharedDives()),
    editDive: (index: any) => dispatch(push(`/app/dive/edit/${index}`)),
    viewDetail: (index: any) => dispatch(push(`/app/dives/${index}`)),
    viewSharedDetail: (index: any) =>
        dispatch(push(`/app/shared-dive/${index}`))
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Dashboard.tsx